import cn from 'classnames'
import * as React from 'react'

import styles from './sub-title.module.scss'

interface ISubTitleProps {
  children: React.ReactNode
  className?: string
  color?: 'brand' | 'gray' | 'free'
}

export default function SubTitle(props: ISubTitleProps) {
  const { children, className, color = 'gray' } = props

  return (
    <div className={cn(styles.root, color === 'brand' && 'brand', color === 'free' && styles.free, className)}>
      {children}
    </div>
  )
}
